import _ from 'lodash';

function getRouterDynamicPagePrefix(pageId, documentServices) {
  // Dynamic Router Page - find the router prefix
  const dynamicPages = documentServices.routers.pages.getDynamicPagesList();
  const dynamicPageIndex = _.findIndex(
    dynamicPages,
    dynamicPage =>
      _.findIndex(dynamicPage.pages, page => page.id === pageId) > -1,
  );
  if (dynamicPageIndex >= 0) {
    return dynamicPages[dynamicPageIndex].prefix;
  }

  return undefined;
}

function getApplicationPageSlug(pageId, documentServices) {
  const pageData = documentServices.pages.data.get(pageId);
  if (pageData && pageData.appDefinitionId) {
    // A platformized Application page - the slug is the page uri seo
    return pageData.pageUriSEO;
  }

  return undefined;
}

export function getDynamicPageFirstSlugInnerRoute(pageId, documentServices) {
  const routerPrefix = getRouterDynamicPagePrefix(pageId, documentServices);
  if (routerPrefix) {
    return routerPrefix;
  }
  return getApplicationPageSlug(pageId, documentServices);
}

// Return the comment inner path starting from the page's Slug
// Comment is expected to be dynamic page comment, otherwise returning undefined
export function calcCommentInnerPathFromPageSlug(
  commentLocation,
  documentServices,
) {
  const { innerPath } = commentLocation;
  const dynamicPageFirstSlug = getDynamicPageFirstSlugInnerRoute(
    commentLocation.pageId,
    documentServices,
  );

  if (!dynamicPageFirstSlug) {
    return;
  }

  const slugs = innerPath?.split('/');
  const innerPathSlugIndex = slugs?.indexOf(dynamicPageFirstSlug);
  if (!innerPathSlugIndex || innerPathSlugIndex < 0) {
    return;
  }

  return `./${slugs.slice(innerPathSlugIndex).join('/')}`;
}

export function isDynamicPage(pageId, documentServices) {
  const pageData = documentServices.pages.data.get(pageId);
  if (!pageData) {
    return undefined;
  }

  if (pageData.appDefinitionId) {
    return true;
  }

  return !_.isUndefined(getRouterDynamicPagePrefix(pageId, documentServices));
}
